export enum QuoteStatus {
  PendingApproval = "AGUARDANDO_APROVACAO",
  Approved = "APROVADO",
  Rejected = "REJEITADO",
  AdjustmentRequested = "AJUSTE_SOLICITADO",
}
